module.exports = __webpack_public_path__ + "img/sy_n3_2.cebeef77.jpeg";